/* TheStudiz – mobile bottom bar + search overlay. Sirf clicks aur typing par chalta hai (koi MutationObserver nahi). */
(function () {
  var overlay = document.getElementById('MobileSearch');
  if (!overlay) return;
  var input = overlay.querySelector('.m-search__input');
  var results = document.getElementById('MobileSearchResults');
  var browse = document.getElementById('MobileSearchBrowse');
  var timer = null, controller = null;

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    return (cur === 'PKR' ? 'Rs.' : cur + ' ') + Math.round(n).toLocaleString('en-US');
  }

  function openSearch() {
    overlay.hidden = false;
    document.body.classList.add('m-search-open');
    setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearch() {
    overlay.hidden = true;
    document.body.classList.remove('m-search-open');
  }

  function render(products, q) {
    results.textContent = '';
    if (browse) browse.hidden = !!q;
    if (!q) return;
    if (!products.length) {
      var p = document.createElement('p');
      p.className = 'm-search__empty';
      p.textContent = 'No books found for "' + q + '". Try another name or author.';
      results.appendChild(p);
      return;
    }
    var list = document.createElement('ul');
    list.className = 'm-search__list';
    products.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.url;
      a.className = 'm-search__item';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 52; img.height = 70;
        a.appendChild(img);
      }
      var box = document.createElement('span');
      var title = document.createElement('span');
      title.className = 'm-search__title'; title.textContent = item.title;
      var price = document.createElement('span');
      price.className = 'm-search__price'; price.textContent = money(item.price);
      var cmp = parseFloat(item.compare_at_price_max);
      if (cmp > parseFloat(item.price)) {
        var s = document.createElement('s'); s.textContent = money(cmp); price.appendChild(document.createTextNode(' ')); price.appendChild(s);
      }
      box.appendChild(title); box.appendChild(price); a.appendChild(box); li.appendChild(a); list.appendChild(li);
    });
    results.appendChild(list);
    var all = document.createElement('a');
    all.className = 'm-search__all';
    all.href = (window.routes && routes.search_url ? routes.search_url : '/search') + '?q=' + encodeURIComponent(q);
    all.textContent = 'See all results for "' + q + '"';
    results.appendChild(all);
  }

  function search(q) {
    if (controller) controller.abort();
    if (!q) { render([], ''); return; }
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var base = (window.routes && routes.predictive_search_url) || '/search/suggest';
    fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
      controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) { render((d.resources && d.resources.results && d.resources.results.products) || [], q); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-m-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-m-search-close]')) { e.preventDefault(); closeSearch(); return; }
    if (t.closest('[data-m-cart]')) {
      e.preventDefault();
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.click(); else window.location = (window.routes && routes.cart_url) || '/cart';
      return;
    }
    if (t === overlay) closeSearch();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeSearch(); });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { search(q); }, 250);
  });

  /* Cart count: add-to-cart ke baad header ke bubble se number copy karo. */
  function syncCount() {
    var badge = document.querySelector('[data-m-cart-count]');
    if (!badge) return;
    var src = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var n = src ? parseInt(src.textContent, 10) : 0;
    if (n > 0) { badge.textContent = n; badge.hidden = false; } else if (src === null) { badge.hidden = true; }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncCount, 700); });
  }
})();
